import { create } from 'zustand';
import { PriceSurvey } from '../codegen/graphql';

export interface SurveyState {
    survey: PriceSurvey | null;
    setSurvey: (survey: PriceSurvey | null) => void;
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;

    totalItemsCount: number;
    completedItemsCount: number;
    completionPercent: number;
}

export const useSurveyStore = create<SurveyState>(set => ({
    survey: null,
    isLoading: false,

    setSurvey: survey => {
        const totalItemsCount = survey?.totalItemsCount || 0;
        const completedItemsCount = survey?.completedItemsCount || 0;
        const completionPercent =
            totalItemsCount > 0
                ? Math.round((completedItemsCount / totalItemsCount) * 100)
                : 0;

        set({
            survey,
            totalItemsCount,
            completedItemsCount,
            completionPercent,
        });
    },

    setIsLoading: isLoading => set({ isLoading }),

    totalItemsCount: 0,
    completedItemsCount: 0,
    completionPercent: 0,
}));
